import { Formik } from "formik";
import styled from "styled-components";
import * as Yup from "yup";
import { FlexColumn } from "../../../../Common/Styles";
import { CreateRepostHeader } from "./1-Header";
import { CreateRepostContent } from "./2-Content";
import { PostContent } from "./4-PostContent";

export const CreateRepostModalContent = () => {
  return (
    <ModalContainer $gapInPx={16}>
      <Formik
        initialValues={{ content: "" }}
        validationSchema={Yup.object({})}
        onSubmit={() => {}}
        validateOnChange={false}
        isInitialValid={false}
        validateOnBlur
      >
        {() => (
          <>
            <CreateRepostHeader />
            <CreateRepostContent />
          </>
        )}
      </Formik>
      <PostContent />
    </ModalContainer>
  );
};

const ModalContainer = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;
